import React, { Children, useEffect } from "react";
import { useHistory } from "react-router-dom";
import appState from "src/model/state";

export const RouteInitializerProvider = ({ children }: any) => {
  const { navigation } = appState.get();
  const history = useHistory();
  useEffect(() => {
    if(navigation.initialPath){
      history.replace(navigation.initialPath);
      appState.execute("SET_DEFAULT_INIT",null);
    }
  }, [navigation.initialPath]);

  return <>{children}</>;
};
